import { useEffect } from 'react';
import { useNavigate } from '@remix-run/react';
import { BaseButtonUiComponent } from '@brightcove/web-sdk/dist/ui/index.es.js';

import { track } from '~/services/analytics/index.client.ts';
import { getVideoItemParentUrl } from '~/components/player/utils';
import { getNavItemAnalyticsData } from '~/utils/analytics';

import type { Player } from '@brightcove/web-sdk/ui';
import type { FeedEntry } from '~/services/layout';

const usePlayerTopBar = (
  player: Player | null,
  playableItem: FeedEntry,
  analyticsTrackData: any
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!player) return;

    const uiManager = player.getUiManager();
    const playerComponent = uiManager.getPlayerContainerUiComponent();

    if (!playerComponent) return;

    const backButton = new BaseButtonUiComponent({
      name: 'BackButotn',
      componentOptions: {
        className: 'text-white pointer-events-auto',
        clickHandler: () => {
          if (!document.pictureInPictureElement) player.dispose();

          const parentUrl: string = getVideoItemParentUrl(playableItem);

          navigate(parentUrl);

          const { eventName, trackData } = getNavItemAnalyticsData(
            'tap_navbar_back_button',
            analyticsTrackData
          );
          track(eventName, trackData);
        },
      },
    });

    backButton.getDOMElement().innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="w-9 h-9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5M12 19l-7-7 7-7"/>
      </svg>
    `;

    const controlBarComponent = playerComponent.getChild('TitleBar');

    if (controlBarComponent) {
      backButton.show();
      // @ts-ignore
      controlBarComponent.updateTitle(playableItem?.title);
      controlBarComponent.addChild(backButton);
      controlBarComponent.addClass(
        'pl-5 pt-5 text-lg vjs-hidden flex flex-row-reverse justify-end items-center'
      );
      controlBarComponent.show();
    }
  }, [player, playableItem]);
};

export default usePlayerTopBar;
